export default __webpack_public_path__ + "static/media/propeller_lat.227b6cb6.gif";